<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <empty-form> </empty-form>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-11 col-md-10">
        <emptied></emptied>
      </div>
    </div>
  </div>
</template>
<script>
import EmptyForm from "./Empty/EmptyForm.vue";
import Emptied from "@/pages/Emptied.vue";
export default {
  components: {
    EmptyForm,
    Emptied
  },
};
</script>
<style>
</style>